import { required } from "vuelidate/lib/validators";

export const meioPagamentoPermiteTaxaAdministracao = (idMeioPagamento) =>
  [3, 4, 17, 20].includes(Number(idMeioPagamento));

export const localizarOpcaoPorId = (opcoes = [], id) => {
  if (id === null || id === undefined) {
    return null;
  }

  return opcoes.find(opcao => String(opcao.id) === String(id)) || null;
};

export default class ParcelamentoData {
  descricao = null;
  tipo_repeticao = null;
  id_meio_pagamento = null;
  vezes = null;
  visualizar = true;
  visualizar_app = true;
  informar_cliente = false;
  movimento_caixa = false;
  banco = null;
  taxa = null;
  id_plano_contas_taxa = null;
  plano_contas_taxa = null;
  constructor({
    descricao = null,
    tipo_repeticao = null,
    id_meio_pagamento = null,
    vezes = null,
    visualizar = true,
    visualizar_app = true,
    informar_cliente = false,
    movimento_caixa = false,
    banco = null,
    taxa = null,
    id_plano_contas_taxa = null,
    plano_contas_taxa = null,
  }) {
    this.descricao = descricao;
    this.tipo_repeticao = tipo_repeticao;
    this.id_meio_pagamento = id_meio_pagamento;
    this.vezes = vezes;
    this.visualizar = visualizar;
    this.visualizar_app = visualizar_app;
    this.informar_cliente = informar_cliente;
    this.movimento_caixa = movimento_caixa;
    this.banco = banco;
    this.taxa = taxa;
    this.id_plano_contas_taxa = id_plano_contas_taxa;
    this.plano_contas_taxa = plano_contas_taxa;
  }
}

export const ParcelamentoDataRequired = {
  descricao: {
    required,
  },
};
